<template>
  <div class="header-container">
    <div>
      <div>PROG KIT 56-0948-8872643</div>
      <div>///PTK ERROR RESTART 007</div>
    </div>
    <div class="hidden sm:block">C.P. 56-0948-8872643</div>
    <div class="header-user">
      USER NO. {{ username }}
    </div>
    <div />
    <div class="hidden sm:block">
      <div>PROG KIT 56-0948-8872643</div>
      <div>PROG KIT 56-0948-8872643</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SectionLayoutFooterDark',

  computed: {
    ...mapGetters({
      username: 'auth/username',
    }),
  },
}
</script>

<style lang="postcss" scoped>
.header {
  &-container {
    font-family: 'input-mono';
    font-size: 12px;
    @apply text-blue flex items-end justify-between pl-4 pt-2 pb-4 bg-almost-black w-full;
  }

  &-user {
    @apply bg-blue text-blue-lighter p-1;
  }
}
</style>
